import React, { useEffect, useState } from 'react';
import classes from "./SubscriptionInfo.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import Container from '../component/Container';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { subscriptionInfoApi } from '../http/http';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SmallLoader from '../component/SmallLoader';
import { FaArrowLeft, FaUser } from 'react-icons/fa6';

const formatDate = (iso) =>
    new Date(iso).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

const SubscriptionInfo = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await subscriptionInfoApi(userDetails?.token);
                setData(response?.data?.[0]);
            } catch (error) {
                toast.error(
                    error?.response?.data?.error?.error ||
                    error?.response?.error?.error ||
                    error?.response?.error ||
                    t("128")
                );
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <Layout>
            <SubLayout>
                <Header active={4} hide={true} />

                <button type="button" className={classes.back_button} onClick={()=>navigate(-1)}>
                    <FaArrowLeft color='white' />
                </button>

                <Container style={{ gap: "16px" }}>
                    {loading ? (
                        <SmallLoader />
                    ) : data ? (
                        <div className={classes.card}>

                            <div className={classes.header}>
                                <div className={classes.avatar}>
                                    {data.image ? (
                                        <img
                                            src={data.image}
                                            alt="profile"
                                            className={classes.avatarImg}
                                            onError={e => { e.target.style.display = "none"; }}
                                        />
                                    ) : (
                                        <FaUser color='green' />
                                    )}
                                </div>
                                <div className={classes.headerInfo}>
                                    <p className={classes.name}>
                                        {t("143")}
                                    </p>
                                    <p className={classes.mobile}>
                                        {data.mobileNumber}
                                    </p>
                                </div>
                                <div className={classes.activeBadge}>
                                    <span className={classes.dot} />
                                    {t("144")}
                                </div>
                            </div>

                            <div className={classes.body}>
                                <div className={classes.grid}>
                                    <div className={classes.metric}>
                                        <p className={classes.metricLabel}>{t("145")}</p>
                                        <p className={classes.metricValue}>
                                            {data?.packId == "1" ? t("146") : data?.packId == "2" ? t("147") : t("148")}
                                        </p>
                                    </div>
                                    <div className={classes.metric}>
                                        <p className={classes.metricLabel}>Price</p>
                                        <p className={classes.metricValue}>
                                            {data?.packId == "1" ? "300" : data?.packId == "2" ? "700" : "1500"}
                                        </p>
                                        <p className={classes.metricSub}>TSH / {data?.packId == "1" ? "1" : data?.packId == "2" ? "7" : "30"} {t("149")}</p>
                                    </div>
                                </div>

                                <div className={classes.rows}>
                                    <div className={classes.row}>
                                        <span className={classes.rowLabel}>
                                            {t("150")}
                                        </span>
                                        <span className={classes.rowValueMono}>{data.id}</span>
                                    </div>
                                    <div className={classes.row}>
                                        <span className={classes.rowLabel}>
                                            {t("151")}
                                        </span>
                                        <span className={classes.rowValue}>{formatDate(data.createdAt)}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    ) : (
                        <p className={classes.empty}>{t("152")}</p>
                    )}
                    
                </Container>
            </SubLayout>
        </Layout>
    );
};

export default SubscriptionInfo;